export const findNearestScrollContainer = (
  el: HTMLElement | null
): HTMLElement | null => {
  if (!el) return null;

  let node: HTMLElement | null = el.parentElement;

  while (node) {
    const style = window.getComputedStyle(node);
    const overflowX = style.overflowX;
    const overflowY = style.overflowY;

    const canScrollX =
      (overflowX === 'auto' ||
        overflowX === 'scroll' ||
        overflowX === 'overlay') &&
      node.scrollWidth > node.clientWidth;

    const canScrollY =
      (overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay') &&
      node.scrollHeight > node.clientHeight;

    if (canScrollX || canScrollY) {
      return node;
    }

    node = node.parentElement;
  }

  return (document.scrollingElement || document.documentElement) as HTMLElement;
};
